module.exports = __webpack_public_path__ + "img/DE01595.b1021644.png";